"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX = void 0;
exports.MAX = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        let maximum = null;
        for (const input of inputs) {
            // Array inputs
            if (Array.isArray(input)) {
                // eslint-disable-next-line no-restricted-syntax
                for (let rowIdx = 0; rowIdx < input.length; rowIdx += 1) {
                    const arrayElement = input[rowIdx];
                    if (typeof arrayElement !== 'number') {
                        return {
                            error: `All array elements for MAX must consist of numbers, but received [input:${arrayElement}] of [type:${typeof arrayElement}]`,
                        };
                    }
                    maximum =
                        maximum !== null ? Math.max(maximum, arrayElement) : arrayElement;
                }
            }
            else if (typeof input === 'number') {
                // Number inputs
                maximum = maximum !== null ? Math.max(maximum, input) : input;
            }
            else {
                return {
                    error: `Input values for MAX must be numbers or arrays of numbers, but received [input:${input}] of [type:${typeof input}]`,
                };
            }
        }
        if (maximum === null) {
            return {
                error: 'Input values for MAX must contain at least 1 number',
            };
        }
        return { error: null, result: maximum };
    },
};
//# sourceMappingURL=max.js.map